(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[id^="Hero-"]').forEach(function (heroEl) {
      var slides = heroEl.querySelectorAll('.hero__slide');
      var dots = heroEl.querySelectorAll('.hero__slider-dot');
      var intervalMs = (parseInt(heroEl.dataset.slideInterval, 10) || 5) * 1000;
   function isMobileView() {
  return window.matchMedia("(max-width: 749px)").matches;
}

function isAutoSlideEnabled() {
  return isMobileView()
    ? heroEl.dataset.mobileAutoSlide === "true"
    : heroEl.dataset.desktopAutoSlide === "true";
}

var isAutoSlide = isAutoSlideEnabled();
var sliderNav = heroEl.querySelector('.hero__slider-nav');

function updateSliderNav() {
  if (!sliderNav) return;

  if (isMobileView()) {
    sliderNav.style.display =
      heroEl.dataset.mobileAutoSlide === "true" ? "block" : "none";
  } else {
    sliderNav.style.display =
      heroEl.dataset.desktopAutoSlide === "true" ? "none" : "none";
  }
}

updateSliderNav();
window.addEventListener("resize", updateSliderNav);

var currentIndex = 0;
      var timer = null;
      var isPaused = false;

      function getSlideHref(slideEl) {
        if (!slideEl) return '';
        return isMobileView()
          ? slideEl.dataset.mobileLink || slideEl.dataset.desktopLink || ''
          : slideEl.dataset.desktopLink || slideEl.dataset.mobileLink || '';
      }

      function getSlideTargetBlank(slideEl) {
        if (!slideEl) return false;
        return isMobileView()
          ? slideEl.dataset.mobileTab === 'true'
          : slideEl.dataset.desktopTab === 'true';
      }

      slides.forEach(function (slide) {
        slide.addEventListener('click', function (e) {
          if (!slide.classList.contains('hero__slide--active')) return;
          if (e.target.closest('.hero__slider-nav')) return;
          var href = getSlideHref(slide);
          if (!href) return;

          var openInNewTab = getSlideTargetBlank(slide);
          if (openInNewTab) {
            window.open(href, '_blank', 'noopener');
          } else {
            window.location.href = href;
          }
        });
      });
      slides.forEach(function (slide) {
  function updateCursor() {
    slide.style.cursor = getSlideHref(slide) ? "pointer" : "default";
  }

  updateCursor();
  window.addEventListener("resize", updateCursor);
});

      function setActiveDot(idx) {
        dots.forEach(function (dot) {
          var fill = dot.querySelector('.hero__slider-dot-fill');
          dot.classList.remove('hero__slider-dot--active');
          if (fill) {
            fill.style.transition = 'none';
            fill.style.width = '0%';
          }
        });

        if (dots[idx]) {
          dots[idx].classList.add('hero__slider-dot--active');
          var fill = dots[idx].querySelector('.hero__slider-dot-fill');
          if (fill && isAutoSlide) {
            fill.offsetHeight;
            fill.style.transition = 'width ' + intervalMs + 'ms linear';
            fill.style.width = '100%';
          }
        }
      }

      function goToSlide(idx) {
        slides[currentIndex].classList.remove('hero__slide--active');
        currentIndex = idx;
        slides[currentIndex].classList.add('hero__slide--active');
        setActiveDot(idx);
      }

      function nextSlide() {
        var next = (currentIndex + 1) % slides.length;
        goToSlide(next);
      }

    function startTimer() {
  if (!isAutoSlideEnabled()) return;

  stopTimer();
  setActiveDot(currentIndex);
  timer = setInterval(nextSlide, intervalMs);
}

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(i);
          if (isAutoSlide) {
            startTimer();
          }
        });
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopTimer();
        } else if (!isPaused && isAutoSlide) {
          startTimer();
        }
      });

      slides.forEach(function (s) { s.classList.remove('hero__slide--active'); });
      slides[currentIndex].classList.add('hero__slide--active');
      
      if (isAutoSlide) {
        startTimer();
      } else {
        setActiveDot(currentIndex);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
